import type { CSSProperties } from 'react';
import CheckCircleFilledSvg from '../../assets/icons/check_circle_filled.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const CheckCircleFilled: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <CheckCircleFilledSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default CheckCircleFilled;
